
export default function Form() {
    const inputs = document.querySelectorAll('input');

    inputs && inputs.forEach(input => {
        if(input.type === 'text') {
            input.addEventListener('input', validateText);
        }

        if(input.type === 'email') {
            input.addEventListener('input', validateEmail);
        }

        if(input.type === 'tel') {
            input.addEventListener('input', validatePhone)
        }
    })

    function validateText() {
        const textPattern = /^[a-zA-Zа-яА-ЯёЁ0-9\s@.,_\-+/:()&!?']+$/;

        if(!textPattern.test(this.value)) {
            this.value = this.value.slice(0, -1);
        }
        }

    function validateEmail() {
        const emailPattern = /^[a-zA-Z0-9._%+-]*@?[a-zA-Z0-9.-]*\.?[a-zA-Z]{0,}$/;

        if (!emailPattern.test(this.value)) {
            this.value = this.value.slice(0, -1);
        }
    }

    function validatePhone() {
        const phonePattern = /^\+?[0-9]*$/;

        if (!phonePattern.test(this.value)) {
            this.value = this.value.slice(0, -1);
        }
    }
    }
